const planeFragment2 = "precision lowp float;precision lowp int;varying float v_noise;uniform float time;uniform vec3 color1;uniform vec3 color2;void main(void){float transparent=0.88;gl_FragColor=vec4(mix(color1,color2,smoothstep(0.0,0.7,-v_noise)),transparent);}";

export { planeFragment2 as default };
